import type { ReactNode } from 'react';

/** Titulo de secao da home (h2 Cinzel + subtitulo + acao opcional a direita). */
// reveal=false pra secao que monta DEPOIS do fetch (o useReveal so' observa o que existe no mount).
export function SectionTitle({ title, subtitle, action, reveal = true }: { title: string; subtitle: string; action?: ReactNode; reveal?: boolean }) {
  return (
    <div className={`section-title-row${reveal ? ' reveal' : ''}`}>
      <div>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>
      {action}
    </div>
  );
}

/** Divisor ornamental entre secoes. */
export function Ornament() {
  return (
    <div className="ornament" aria-hidden="true">
      <span></span><img src="/assets/liberty/ui/ornament.svg" alt="" /><span></span>
    </div>
  );
}
